<template>
    <form
        class="form-horizontal"
        enctype="multipart/form-data"
        autocomplete="off"
    >
        <rea-loader :loading="loading"/>

        <h4>{{ uLang('app.invoice_info') }}</h4>

        <div class="row form-group" v-if="type === 'sales' || type === 'credit'">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.invoice_number') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.number"
                    readonly
                    required
                >
            </div>
        </div>

        <div class="row form-group" v-if="type === 'buy'">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.invoice_number') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.number_by_coach"
                    readonly
                    required
                >
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.invoice_date') }}</label>
            <div class="col-md-9 col-sm-12">
                <vue-pikaday
                    v-model="invoice.invoice_date"
                    :options="pikadayOptions"
                    :required="true"
                    class="form-control"
                    autocomplete="off"
                />
                <span class="invalid-feedback" v-text="getError('invoice_date')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.expired_at') }}</label>
            <div class="col-md-9 col-sm-12">
                <vue-pikaday
                    v-model="invoice.expired_at"
                    :options="pikadayOptions"
                    required
                    class="form-control"
                    autocomplete="off"
                />
                <span class="invalid-feedback" v-text="getError('expired_at')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.organisation') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.organisation"
                    required
                >
                <span class="invalid-feedback" v-text="getError('organisation')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.to_the_attention_of') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.name"
                    required
                >
                <span class="invalid-feedback" v-text="getError('name')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.email') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.email"
                    required
                >
                <span class="invalid-feedback" v-text="getError('email')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.address') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.address"
                    required
                >
                <span class="invalid-feedback" v-text="getError('address')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.house_number') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.address_number"
                    required
                >
                <span class="invalid-feedback" v-text="getError('address_number')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.zipcode') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.zipcode"
                    required
                >
                <span class="invalid-feedback" v-text="getError('zipcode')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.city') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.city"
                    required
                >
                <span class="invalid-feedback" v-text="getError('city')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.concerning') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.concerning"
                    required
                >
                <span class="invalid-feedback" v-text="getError('concerning')" />
            </div>
        </div>

<!--        <div class="row form-group">-->
<!--            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.anonymize_invoice') }}</label>-->
<!--            <div class="col-md-9 col-sm-12">-->
<!--                <label class="custom-control custom-checkbox mt-2">-->
<!--                    <input type="checkbox" class="custom-control-input" id="is_anonymous" value="1" v-model="invoice.is_anonymous">-->
<!--                    <span class="custom-control-indicator"></span>-->
<!--                </label>-->
<!--            </div>-->
<!--        </div>-->

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.vat_number') }} ({{ lang('app.optional') }})</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.vat_number"
                >
                <span class="invalid-feedback" v-text="getError('vat_number')" />
            </div>
        </div>

        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.order_number') }} ({{ lang('app.optional') }})</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="invoice.order_number"
                >
                <span class="invalid-feedback" v-text="getError('order_number')" />
            </div>
        </div>

        <h4 class="mt-4">{{ uLang('app.invoice_rows') }}</h4>

        <table class="table table-striped">
            <tr>
                <th>{{ uLang('app.description') }}</th>
                <th>{{ uLang('app.price_no_vat') }}</th>
                <th>{{ uLang('app.vat_percentage') }}</th>
                <th></th>
            </tr>
            <tr v-if="hasNoInvoiceRows">
                <td colspan="4">{{ uLang('app.empty_table') }}</td>
            </tr>
            <tr class="invalid-feedback" v-if="getError('rows') && hasNoInvoiceRows">
                <td colspan="4">{{ getError('rows') }}</td>
            </tr>
            <tr v-for="(row, key) in invoice.rows" :key="key">
                <td>
                    <input
                            type="text"
                            class="form-control"
                            v-model="row.description"
                    >
                    <span class="invalid-feedback" v-text="getError(`rows.${key}.description`)" />
                </td>
                <td>
                    <input
                            type="text"
                            class="form-control"
                            v-model="row.price_no_vat"
                    >
                    <span class="invalid-feedback" v-text="getError(`rows.${key}.price_no_vat`)" />
                </td>
                <td>
                    <input
                            type="text"
                            class="form-control"
                            v-model="row.vat_percentage"
                    >
                    <span class="invalid-feedback" v-text="getError(`rows.${key}.vat_percentage`)" />
                </td>
                <td>
                    <v-popover
                        offset="16"
                        position="top"
                        :disabled="!row.action_progress_id"
                    >
                        <button
                            type="button"
                            class="btn btn-danger btn-input-block tooltip-target b3"
                            @click="() => instantDeleteRowWithoutActionProgress(row, key)"
                        >
                            <i class="fa fa-trash"></i>
                        </button>

                        <template slot="popover">
                            <p v-text="lang('app.delete_invoice_row_explanation')" />

                            <button
                                v-close-popover
                                type="button"
                                class="btn btn-sm btn-secondary-outline"
                                v-text="uLang('app.cancel')"
                            />
                            <button
                                v-close-popover
                                type="button"
                                class="btn btn-sm btn-danger"
                                v-text="uLang('app.continue')"
                                @click="deleteInvoiceRow(key)"
                            />
                        </template>
                    </v-popover>
                </td>
            </tr>
        </table>

        <div class="row mb-5">
            <div class="col-sm-12">
                <button type="button" @click="addInvoiceRow" class="btn"><i class="fa fa-plus"></i> {{ uLang('app.add_invoice_row') }}</button>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">


                <button
                    type="button"
                    @click.prevent="updateInvoice"
                    class="btn btn-brand"
                >
                    {{ uLang('app.save') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import { ConfirmationAlert, SuccessAlert } from "~/Swals";
    import { PikadayOptions } from '~/Form/elements'
    import { ReaLoader } from '~/components/helpers'

    export default {
        components: {
            ReaLoader,
        },

        props: {
            type: {
                type: String,
                validator: (type) => {
                    return ['sales', 'credit', 'buy'].includes(type)
                }
            },

            invoiceId: {
                required: true,
            },
        },

        data() {
            return {
                pikadayOptions: PikadayOptions,
                loading: false,
                errors: {},

                invoice: {
                    id: null,
                    number: null,
                    number_by_coach: null,
                    invoice_date: null,
                    expired_at: null,
                    organisation: null,
                    name: null,
                    email: null,
                    address: null,
                    address_number: null,
                    zipcode: null,
                    city: null,
                    vat_number: null,
                    buy_for: null,
                    concerning: null,
                    order_number: null,
                    is_anonymous: false,
                    rows: []
                },
            }
        },

        computed: {
            hasNoInvoiceRows() {
                return !this.invoice.rows || this.invoice.rows.length === 0
            }
        },

        methods: {
            updateInvoice() {
                new ConfirmationAlert({
                    text: this.uLang('app.confirm_entity_update', { entity: this.lang(`app.${this.type}_invoice`) }),
                })
                    .show()
                    .then(() => {
                        this.loading = true

                        return this.commitUpdateInvoice()
                    })
                    .then(({ data }) => {
                        this.$emit('invoiceUpdated', data)

                        return new SuccessAlert({
                            title: uLang('app.invoice'),
                            text: this.uLang('app.entity_updated', {
                                entity: this.lang(`app.${this.type}_invoice`)
                            })
                        }).show();
                    })
                    .catch(({ response }) => {
                        this.errors = response.data.errors
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },

            commitUpdateInvoice() {
                const url = window.route(`invoices.${this.type}.update`, { invoice: this.invoiceId })

                return window.axios.put(
                    url,
                    Object.assign({}, this.$data.invoice, this.transformDatesToBackend(this.$data.invoice))
                )
            },

            fetchInvoice() {
                this.loading = true

                const url = window.route(`invoices.${this.type}.edit`, { invoice: this.invoiceId })

                window.axios.get(
                    url,
                    Object.assign({}, this.$data)
                ).then(({ data }) => {
                    this.$data.invoice = Object.assign(
                        {}, // Start with base object
                        data, // Overwrite with data from backend
                        this.transformDates(data) // Overwrite some data properties
                    )
                }).finally(() => {
                    this.loading = false
                })
            },

            addInvoiceRow() {
                this.invoice.rows.push({})
            },

            deleteInvoiceRow(index) {
                this.invoice.rows.splice(index, 1)
            },

            // No need to verify deletion of row if it doesn't have an action_progress_id
            instantDeleteRowWithoutActionProgress({ action_progress_id }, key) {
                if (action_progress_id) {
                    return;
                }

                this.deleteInvoiceRow(key)
            },

            transformDates({ expired_at, invoice_date }) {
                return {
                    expired_at: new Date(expired_at),
                    invoice_date: new Date(invoice_date)
                }
            },

            transformDatesToBackend({ expired_at, invoice_date }) {
                return {
                    expired_at: expired_at.toLocaleString('nl-NL'),
                    invoice_date: invoice_date.toLocaleString('nl-NL')
                }
            },

            getError(fieldName) {
                if (!this.errors.hasOwnProperty(fieldName)) {
                    return ''
                }

                let error = this.errors[fieldName][0]; // first error for this field

                return error.charAt(0).toUpperCase() + error.slice(1)
            }
        },

        mounted() {
            this.fetchInvoice()
        }
    }
</script>

<style>
    .invalid-feedback {
        color: red;
    }

    .btn-input-block {
        height: 35px;
        width: 35px;
    }
</style>
